var _polygon, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.75,309a4.12,4.12,0,0,0,1.8-1.21,3.81,3.81,0,0,0,.88-2.43,5.8,5.8,0,0,0-.29-1.66c-.15-.59-.31-1.23-.47-1.9-1.35-5.41-3.27-13.19-5.65-22.77l-1.85-7.55q-.48-2-1-4a11.45,11.45,0,0,0-.57-2,3.51,3.51,0,0,0-1.32-1.46,3.31,3.31,0,0,0-1.92-.47,17.29,17.29,0,0,0-2.13.48l-4.43,1.16-9.27,2.4-41.25,10.66a3.48,3.48,0,0,0-2.48,3.93c.44,1.81.87,3.6,1.29,5.39.87,3.57,1.72,7.1,2.56,10.56,1.67,6.93,3.29,13.61,4.82,20,.19.8.39,1.59.57,2.37a3.65,3.65,0,0,0,1,1.93,3.34,3.34,0,0,0,1.92.92,5.73,5.73,0,0,0,2.18-.34l8.75-2.23,15.7-4L193.39,311l6.19-1.52,1.62-.38.55-.11a3.65,3.65,0,0,1-.54.18l-1.59.45-6.16,1.66-22.69,6-15.68,4.09-8.74,2.27a6.48,6.48,0,0,1-2.42.36,4,4,0,0,1-2.3-1.08,4.46,4.46,0,0,1-1.22-2.25c-.19-.79-.38-1.58-.58-2.37-1.55-6.37-3.17-13-4.86-20l-2.57-10.56q-.65-2.7-1.3-5.44a4.19,4.19,0,0,1,3-4.75l41.27-10.61,9.27-2.37,4.44-1.14a18,18,0,0,1,2.24-.5,4,4,0,0,1,2.28.58,4.16,4.16,0,0,1,1.54,1.71,13.16,13.16,0,0,1,.6,2.1q.5,2.06,1,4c.63,2.63,1.24,5.16,1.81,7.57,2.28,9.61,4.13,17.4,5.42,22.82l.45,1.91a6.32,6.32,0,0,1,.26,1.73,4,4,0,0,1-1,2.52,3.77,3.77,0,0,1-1.37,1A1.92,1.92,0,0,1,201.75,309Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.37 288.97 178.21 291.64 171.58 298.24 164.95 304.84 162.74 295.57 160.52 286.3 169.37 288.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.67,
    y: 308.22,
    width: 89.81,
    height: 71.8,
    transform: "translate(-49.65 116.63) rotate(-9.93)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.77,
    y: 312.75,
    width: 83.5,
    height: 62.76,
    transform: "translate(-49.65 116.62) rotate(-9.93)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "610.81 382.24 632.81 338.78 654.81 359.71 664.63 344.74 693.06 367.84 610.81 382.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.33,329.64a6.57,6.57,0,1,1-7.61-5.35A6.57,6.57,0,0,1,657.33,329.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.67,
    y: 335.37,
    width: 48.29,
    height: 60.4,
    transform: "translate(-78.82 621.19) rotate(-71.28)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.67,
    y: 337.48,
    width: 42.21,
    height: 56.15,
    transform: "translate(-78.84 621.15) rotate(-71.28)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.41 376.53 387.4 357.98 393.64 377.42 404.26 371.76 413.59 394.56 360.41 376.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.83,360.49a4.42,4.42,0,1,1-2.77-5.61A4.43,4.43,0,0,1,404.83,360.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 584.52,
    cy: 75.71,
    r: 40.24,
    transform: "translate(117.66 435.49) rotate(-45)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.79,77a7,7,0,0,1-1.42.1l-3.91.08c-3.32,0-7.94.07-13.16.08H584V74.34c0-5.83,0-11.1.07-14.92,0-1.84.06-3.37.08-4.53a10,10,0,0,1,.11-1.65,11,11,0,0,1,.1,1.65c0,1.16.05,2.69.08,4.53,0,3.82.08,9.09.08,14.92,0,.9,0,1.78,0,2.61l-.25-.26c5.22,0,9.84,0,13.16.09l3.91.08A8.9,8.9,0,0,1,602.79,77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.42,42.08a11.39,11.39,0,0,1,.26,3.38,11.33,11.33,0,0,1-.26,3.38,11.33,11.33,0,0,1-.26-3.38A11.39,11.39,0,0,1,584.42,42.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.76,47.51a11.15,11.15,0,0,1-2.18,2.54A10.65,10.65,0,0,1,598,52.22a10.85,10.85,0,0,1,2.18-2.54A10.72,10.72,0,0,1,602.76,47.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.48,59.22a14.13,14.13,0,0,1-2.78,1.85,13.68,13.68,0,0,1-2.92,1.61,9.15,9.15,0,0,1,2.65-2A9,9,0,0,1,613.48,59.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.76,76.6a41,41,0,0,1-9.22,0,41,41,0,0,1,9.22,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.84,76a36.6,36.6,0,0,1-8.71,0,36.6,36.6,0,0,1,8.71,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.36,88.93a19.35,19.35,0,0,1-3.29,3,18.57,18.57,0,0,1-3.62,2.58,19.83,19.83,0,0,1,3.29-3A19.11,19.11,0,0,1,560.36,88.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.51,98.94a30.26,30.26,0,0,1-2.24,3.88,30.78,30.78,0,0,1-2.37,3.8,14.27,14.27,0,0,1,1.93-4.07A14.41,14.41,0,0,1,571.51,98.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.42,111.84a20.89,20.89,0,0,1-.26-4.61,21,21,0,0,1,.26-4.61,21,21,0,0,1,.26,4.61A20.89,20.89,0,0,1,584.42,111.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.29,105.7a13.39,13.39,0,0,1-3.8-2.6,13.88,13.88,0,0,1-3.1-3.41,41.93,41.93,0,0,1,3.44,3A43.34,43.34,0,0,1,604.29,105.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.61,95.66A16.31,16.31,0,0,1,610.56,93a16.1,16.1,0,0,1-2.68-3,16.1,16.1,0,0,1,3,2.68A15.89,15.89,0,0,1,613.61,95.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.94,63.59a12,12,0,0,1-2.7-2.32,12.29,12.29,0,0,1-2.32-2.7,12.53,12.53,0,0,1,2.69,2.33A12.53,12.53,0,0,1,559.94,63.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.44,51.47a11.84,11.84,0,0,1-2.64-2.27,11.57,11.57,0,0,1-2.28-2.64,12.17,12.17,0,0,1,2.64,2.27A11.42,11.42,0,0,1,571.44,51.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.56,
    y: 124.29,
    width: 70.31,
    height: 101.91,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.04,
    y: 124.29,
    width: 70.31,
    height: 101.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.77,
    y: 135.32,
    width: 52.84,
    height: 79.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.61,215.16s0-.13,0-.39,0-.64,0-1.13c0-1,0-2.47,0-4.38,0-3.83,0-9.4-.05-16.45,0-14.08,0-34-.08-57.49l.17.18H646.77l.19-.19c0,30.12,0,57.89,0,79.84l-.15-.15,38.46.08,10.63,0h2.79l1,0-.93,0h-2.76l-10.59,0-38.56.08h-.15v-.15c0-21.95,0-49.72,0-79.84v-.19h.2l52.83,0h.18v.17c0,23.53-.07,43.5-.09,57.61,0,7,0,12.59-.05,16.4,0,1.9,0,3.35,0,4.35,0,.48,0,.85,0,1.11S699.61,215.16,699.61,215.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.54,124.29a11.44,11.44,0,0,1-1.25,1.82c-.82,1.09-2,2.57-3.3,4.18s-2.56,3-3.47,4a12.88,12.88,0,0,1-1.55,1.58,13.12,13.12,0,0,1,1.34-1.76c.94-1.14,2.1-2.55,3.39-4.1l3.38-4.11A12.62,12.62,0,0,1,708.54,124.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.88,214.9a64.82,64.82,0,0,0,9.22,11.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.1,226.43a10.3,10.3,0,0,1-1.61-1.46,49.11,49.11,0,0,1-3.48-3.92,50.28,50.28,0,0,1-3.06-4.26,10.42,10.42,0,0,1-1.07-1.89,14.51,14.51,0,0,1,1.3,1.74c.77,1.09,1.86,2.58,3.13,4.17s2.49,3,3.38,4A14.86,14.86,0,0,1,709.1,226.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,226.12l9.21-11.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.23,214.76a69.7,69.7,0,0,1-4.45,5.8,69.8,69.8,0,0,1-4.76,5.56,70,70,0,0,1,4.46-5.8A68.84,68.84,0,0,1,647.23,214.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,124.29a60,60,0,0,1,4.48,5.34,65.63,65.63,0,0,1,4.17,5.58,60.75,60.75,0,0,1-4.47-5.34A66.44,66.44,0,0,1,638,124.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.46,
    y: 151.53,
    width: 17.69,
    height: 50.24,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.62 166.2 160.62 239.08 55.95 239.08 52.18 166.71 160.62 166.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.41,
    y: 150.48,
    width: 72.21,
    height: 104.67,
    transform: "translate(-98.3 307.34) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.35,239.42H51.69v-73.2H157.35Zm-104.67-1H156.35V167.21H52.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 175.68,
    width: 81.99,
    height: 54.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.51,175.68l-.4,0h-1.17l-4.5,0-16.9.06-59,.12.24-.24c0,16.58,0,35,0,54.27h0l-.26-.26,82,.06-.2.2c0-16.51.08-30,.11-39.48,0-4.72,0-8.4.05-10.92,0-1.25,0-2.21,0-2.87s0-1,0-1,0,.32,0,1,0,1.6,0,2.83c0,2.51,0,6.18.05,10.87,0,9.46.06,23,.11,39.61v.21h-.21l-82,.05h-.26V230h0c0-19.31,0-37.69,0-54.27v-.23h.24l59.18.11,16.84.07,4.46,0h1.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.18,166.51a8.22,8.22,0,0,1,1.8,1.17c1.07.77,2.53,1.87,4.11,3.12s3,2.46,3.93,3.35a8.2,8.2,0,0,1,1.5,1.53c-.1.11-2.61-2-5.76-4.47A58.31,58.31,0,0,1,52.18,166.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85,166.71a51.32,51.32,0,0,1-5.51,4.69,48.77,48.77,0,0,1-5.83,4.28A51.84,51.84,0,0,1,151,171,51,51,0,0,1,156.85,166.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,238.93l-11.67-9.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,229.48a53.59,53.59,0,0,1,6,4.52,56.24,56.24,0,0,1,5.67,4.93,54,54,0,0,1-6-4.52A56.24,56.24,0,0,1,145.1,229.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.18,238.92a52,52,0,0,1,5.45-4.64,50.73,50.73,0,0,1,5.77-4.23A49.54,49.54,0,0,1,58,234.69,47.42,47.42,0,0,1,52.18,238.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.88,
    y: 175.88,
    width: 18.17,
    height: 51.59,
    transform: "translate(-95.71 307.64) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.39,461.8c0,.15-148.83.26-332.37.26S42.61,462,42.61,461.8s148.79-.26,332.41-.26S707.39,461.66,707.39,461.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 67.61,
    width: 71.8,
    height: 89.81,
    transform: "translate(26.62 255.47) rotate(-82.33)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7,82.93l-.44-.05L207,82.73l-4.84-.63-18.23-2.39-64.28-8.54.26-.2c-2.84,21.18-6.11,45.47-9.56,71.16h0l-.22-.3,89,12-.24.19,7.06-51.6c.86-6.21,1.54-11.08,2-14.41q.34-2.49.54-3.81c.12-.86.2-1.31.2-1.31s0,.43-.15,1.28L208.07,88c-.44,3.33-1.07,8.19-1.88,14.39-1.65,12.45-4,30.27-6.86,51.76l0,.21-.21,0-89-11.94-.26,0,0-.26h0l9.61-71.15,0-.23.23,0,64.4,8.79L202.29,82l4.78.67,1.22.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.96,
    y: 70.76,
    width: 62.76,
    height: 83.5,
    transform: "translate(26.58 255.41) rotate(-82.33)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.78 138.03 147.89 103.26 162.54 129.87 176.42 118.57 196.53 149.18 113.78 138.03",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,102a6.57,6.57,0,1,1-5.64-7.39A6.56,6.56,0,0,1,174,102Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "113.78 138.03 147.89 103.26 162.54 129.87 176.42 118.57 196.53 149.18 113.78 138.03"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174,102a6.57,6.57,0,1,1-5.64-7.39A6.56,6.56,0,0,1,174,102Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 196.38,
    y: 70.48,
    width: 367.41,
    height: 240.56,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.93,87.4c0,.14-82.26.26-183.71.26s-183.71-.12-183.71-.26,82.24-.26,183.71-.26S564.93,87.26,564.93,87.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.4,79.55a2.11,2.11,0,1,1-2.11-2.11A2.1,2.1,0,0,1,209.4,79.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,79.55a2.11,2.11,0,1,1-2.11-2.11A2.1,2.1,0,0,1,217,79.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.62,79.55a2.11,2.11,0,1,1-2.1-2.11A2.1,2.1,0,0,1,224.62,79.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.04,
    y: 100.15,
    width: 125.39,
    height: 6.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.35,293.82c0-1.57-.07-67.12-.19-174.54l.19.19-329.42.07h0l.27-.26c0,61.63,0,120.67,0,174.54l-.25-.25,329.45.25-329.45.24h-.24v-.24c0-53.87,0-112.91,0-174.54V119h.29l329.42.06h.2v.2C544.43,226.7,544.36,292.25,544.35,293.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.46,293.46c-.15,0-.15-39.07,0-87.26s.37-87.27.51-87.27.15,39.07,0,87.27S255.6,293.46,255.46,293.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.33,293.6c-.14,0-.14-39.07,0-87.26s.37-87.27.51-87.27.15,39.07,0,87.27S304.48,293.6,304.33,293.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,293.75c-.15,0-.15-39.08,0-87.27s.37-87.27.51-87.27.15,39.07,0,87.27S353.35,293.75,353.21,293.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.08,293.89c-.14,0-.14-39.08,0-87.27s.37-87.27.51-87.27.15,39.07,0,87.28S402.23,293.89,402.08,293.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,294c-.15,0-.15-39.07,0-87.26s.37-87.27.51-87.27.15,39.06,0,87.27S451.1,294,451,294Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.83,294.17c-.14,0-.14-39.07,0-87.26s.37-87.27.51-87.27.15,39.06,0,87.27S500,294.17,499.83,294.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.35,161.48c0,.14-73.66.26-164.52.26s-164.54-.12-164.54-.26,73.66-.26,164.54-.26S544.35,161.33,544.35,161.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.35,206.2c0,.14-73.66.26-164.52.26s-164.54-.12-164.54-.26,73.66-.26,164.54-.26S544.35,206.05,544.35,206.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.35,250.91c0,.15-73.66.26-164.52.26s-164.54-.11-164.54-.26,73.66-.26,164.54-.26S544.35,250.77,544.35,250.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.21,254.89s-3.9,25.32.16,41.1l39-1.42s-8-25.19-2.93-37.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.37,254s.26,31.11,1.84,40.6l39-1.85s-3.43-30.58-2.11-38.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.24,267c0,.15-5.85.62-13.08,1.05s-13.09.67-13.1.53,5.84-.61,13.07-1.05S251.23,266.89,251.24,267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.25,273.62c0,.15-5.85.62-13.08,1.05s-13.09.67-13.1.53,5.84-.61,13.07-1.05S251.24,273.48,251.25,273.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.62,280.09a9.4,9.4,0,0,1-2.18.32c-1.34.13-3.21.27-5.27.39s-3.92.21-5.27.24a9,9,0,0,1-2.2-.05,9.37,9.37,0,0,1,2.17-.32c1.35-.12,3.21-.26,5.27-.39s3.93-.21,5.28-.24A9.84,9.84,0,0,1,244.62,280.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,123.66s-3.2,26.35.86,42.13l38.33-2s-8-25.69-3-38.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.64,122.73s.26,31.11,1.84,40.6l39-1.85s-3.43-30.58-2.11-38.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.51,135.8c0,.14-5.85.61-13.07,1s-13.1.67-13.11.52,5.84-.61,13.07-1S340.5,135.65,340.51,135.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.52,142.39c0,.14-5.84.61-13.07,1s-13.1.68-13.11.53,5.84-.61,13.08-1.05S340.51,142.24,340.52,142.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,148.86a9.78,9.78,0,0,1-2.17.31c-1.35.13-3.21.27-5.27.39s-3.93.21-5.28.25a8.78,8.78,0,0,1-2.2-.06,9.81,9.81,0,0,1,2.18-.31c1.34-.13,3.21-.27,5.27-.39s3.92-.21,5.27-.25A8.73,8.73,0,0,1,333.89,148.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,253.15s-3.15,28.81.9,44.59l38.5-1.69s-8.25-28.42-3.18-41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,252.22s.26,31.11,1.84,40.6l39-1.85s-3.43-30.58-2.11-38.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.87,265.29c0,.14-5.85.61-13.07,1s-13.1.68-13.11.53,5.84-.61,13.07-1.05S391.86,265.14,391.87,265.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.88,271.88c0,.14-5.85.61-13.07,1s-13.1.67-13.11.53,5.84-.61,13.07-1.05S391.87,271.73,391.88,271.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25,278.35a9.81,9.81,0,0,1-2.18.31c-1.34.13-3.2.27-5.26.39s-3.93.21-5.28.25a9.36,9.36,0,0,1-2.2-.06,9.78,9.78,0,0,1,2.17-.31c1.35-.13,3.21-.27,5.27-.4s3.93-.2,5.28-.24A8.73,8.73,0,0,1,385.25,278.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.88,165.48s-4,24.74.05,40.51l39.09-.84s-8-25.19-2.93-37.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506,164.56s.26,31.1,1.84,40.59l39-1.84s-3.43-30.58-2.11-38.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.9,177.62c0,.15-5.84.61-13.07,1s-13.1.67-13.11.53,5.84-.62,13.08-1S538.89,177.48,538.9,177.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.91,184.21c0,.14-5.84.61-13.07,1s-13.1.67-13.11.53,5.85-.62,13.08-1S538.9,184.07,538.91,184.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.28,190.68a9.23,9.23,0,0,1-2.17.32c-1.35.12-3.21.26-5.27.39s-3.93.21-5.28.24a9.84,9.84,0,0,1-2.2,0,9.4,9.4,0,0,1,2.18-.32c1.34-.13,3.21-.27,5.27-.39s3.92-.21,5.28-.24A9,9,0,0,1,532.28,190.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.84,210.81s-4,24.74.05,40.52l39.09-.84s-8-25.19-2.93-37.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,209.89s.26,31.11,1.84,40.6l39-1.85s-3.43-30.58-2.11-38.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.86,223c0,.15-5.84.62-13.07,1.05s-13.1.67-13.11.53,5.84-.61,13.08-1.05S439.85,222.81,439.86,223Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.87,229.54c0,.15-5.84.62-13.07,1.05s-13.1.67-13.11.53,5.85-.61,13.08-1.05S439.86,229.4,439.87,229.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.24,236a9.37,9.37,0,0,1-2.17.32c-1.35.13-3.21.27-5.27.39s-3.93.21-5.28.24a9.15,9.15,0,0,1-2.2-.05,9.4,9.4,0,0,1,2.18-.32c1.34-.12,3.21-.27,5.27-.39s3.92-.21,5.27-.24A9.73,9.73,0,0,1,433.24,236Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497 174.75 476.29 185.41 466.27 183.99 471.63 174.49 493.48 166.79 497 174.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.41 182.03 470.49 173.86 492.93 165.71 497.44 174.58 475.68 183.27 465.41 182.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.41,171a12.62,12.62,0,0,1-2.18,1c-1.36.56-3.25,1.3-5.35,2.1l-5.39,2c-1.37.5-2.28.8-2.22.77-.17-.21,3.24-1.67,7.42-3.27S490.35,170.82,490.41,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.9,175a31.14,31.14,0,0,1-10,3.72,44.91,44.91,0,0,1,5-1.92A45.48,45.48,0,0,1,486.9,175Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,164.06s-3.6,34.84,1.19,42.14L255.71,204l-1.92-38.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,164.06s.25,30.31,1.8,39.55l38-1.8s-3.34-29.79-2.05-37.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.06,168.35l.14,0h.41a8.75,8.75,0,0,1,1.58.08,8.63,8.63,0,0,1,2.42.71,8.11,8.11,0,0,1,2.63,2.08,9.26,9.26,0,0,1,1.82,3.66,8.9,8.9,0,0,1-.4,4.7,14.09,14.09,0,0,1-1.07,2.35,24,24,0,0,0-1.22,2.37,20.58,20.58,0,0,0-1.53,5.39l0,.13h-.12l-3.75.06-3.94.06h-.14v-.14a11.19,11.19,0,0,0-1.82-5.19c-.46-.78-1-1.51-1.42-2.25a20.58,20.58,0,0,1-1.34-2.18,7.28,7.28,0,0,1-.59-4.63,9.89,9.89,0,0,1,1.46-3.78,7.25,7.25,0,0,1,2.48-2.23,9.15,9.15,0,0,1,2.33-.9,10.46,10.46,0,0,1,1.55-.26h.55l-.14,0-.4,0a9.73,9.73,0,0,0-1.53.3,9.25,9.25,0,0,0-2.29.93,7.23,7.23,0,0,0-2.39,2.2,9.71,9.71,0,0,0-1.4,3.72,7.1,7.1,0,0,0,.6,4.48,20.89,20.89,0,0,0,1.33,2.15c.46.73,1,1.46,1.43,2.25a11.37,11.37,0,0,1,1.88,5.33l-.14-.14,3.93-.07,3.75-.05-.13.12a20.13,20.13,0,0,1,1.56-5.47,25.53,25.53,0,0,1,1.24-2.39,13.94,13.94,0,0,0,1.06-2.3,8.66,8.66,0,0,0,.42-4.57,9.14,9.14,0,0,0-1.75-3.59,8,8,0,0,0-2.55-2.06,8.74,8.74,0,0,0-2.37-.75,9.53,9.53,0,0,0-1.56-.13h-.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,189.46l0-.12,0-.35-.21-1.36c-.17-1.18-.42-2.89-.59-5,0-.54-.08-1.09-.1-1.67s-.05-1.19,0-1.82a4.94,4.94,0,0,1,.42-1.9,2.89,2.89,0,0,1,1.45-1.45,1.94,1.94,0,0,1,2.07.39,1.46,1.46,0,0,1,.45,1,1.88,1.88,0,0,1-.39,1.09,2.56,2.56,0,0,1-.92.74,4.4,4.4,0,0,1-1.13.37,12.59,12.59,0,0,1-2.39.28,13.88,13.88,0,0,1-2.42-.11,4.54,4.54,0,0,1-1.14-.34,3,3,0,0,1-1-.68,2.09,2.09,0,0,1-.55-1,1.75,1.75,0,0,1,.13-1.13,1.58,1.58,0,0,1,.8-.77,1.31,1.31,0,0,1,1.08,0,2.07,2.07,0,0,1,.81.68,2.83,2.83,0,0,1,.4,1,11,11,0,0,1,.19,1.94c.07,1.25.13,2.42.19,3.48.1,2.13.19,3.85.25,5,0,.59,0,1.05.06,1.37l0,.36v.12a1.13,1.13,0,0,1,0-.12l0-.36c0-.32-.05-.78-.09-1.37-.07-1.19-.17-2.91-.29-5-.06-1.07-.12-2.23-.19-3.48a12.64,12.64,0,0,0-.2-1.92,2.73,2.73,0,0,0-.39-.91,1.84,1.84,0,0,0-.76-.65,1.25,1.25,0,0,0-1-.05,1.42,1.42,0,0,0-.73.72,1.59,1.59,0,0,0-.13,1.05,2,2,0,0,0,.53,1,3.36,3.36,0,0,0,2,1,13.54,13.54,0,0,0,2.39.11,13.34,13.34,0,0,0,2.38-.27,5.08,5.08,0,0,0,1.1-.37,2.42,2.42,0,0,0,.88-.7,1.76,1.76,0,0,0,.36-1,1.3,1.3,0,0,0-.41-1,1.81,1.81,0,0,0-1.95-.37,2.77,2.77,0,0,0-1.39,1.39,5,5,0,0,0-.43,1.86c0,.63,0,1.23,0,1.81s0,1.14.09,1.67c.16,2.12.4,3.83.55,5,.08.59.15,1,.19,1.36l.05.36A1.09,1.09,0,0,1,239,189.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,189.66s.05.47.1,1.26.11,2,.17,3.29l0-.08,2.56,3-.13-.05,3-.17-.13.06,1.47-1.8.74-.89,0,.11c0-1.73-.07-3.37-.11-4.87l.16.15-5.52.06h-1.6a4.37,4.37,0,0,1-.6,0,2.79,2.79,0,0,1,.53,0l1.56-.08,5.62-.22h.16v.16c0,1.5.09,3.14.14,4.87v.07l-.05,0c-.24.29-.49.59-.73.9-.51.61-1,1.21-1.48,1.79l-.05.06h-.08l-3,.14h-.08l0-.06-2.51-3,0,0v-.05c0-1.31,0-2.43,0-3.37C234,190.06,234,189.64,234,189.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.64,193.94a1.53,1.53,0,0,1-.28-.12c-.18-.08-.44-.19-.77-.3a7.64,7.64,0,0,0-2.67-.41,7.51,7.51,0,0,0-2.64.57,7.12,7.12,0,0,0-.75.35l-.27.13a1.22,1.22,0,0,1,.25-.17,5.58,5.58,0,0,1,.73-.39,7.12,7.12,0,0,1,2.68-.61,7.23,7.23,0,0,1,2.7.45,6,6,0,0,1,.76.34A1.18,1.18,0,0,1,241.64,193.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.64,192.76l-.28-.12c-.18-.08-.44-.19-.77-.31a7.66,7.66,0,0,0-2.67-.4,7.51,7.51,0,0,0-2.64.57,5.53,5.53,0,0,0-.75.35,1.39,1.39,0,0,1-.27.13s.08-.07.25-.17a4.58,4.58,0,0,1,.73-.39,7.09,7.09,0,0,1,5.38-.16,5.29,5.29,0,0,1,.76.34A1.18,1.18,0,0,1,241.64,192.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57,191.63a1.53,1.53,0,0,1-.28-.12c-.18-.08-.44-.19-.77-.3a7.64,7.64,0,0,0-2.67-.41,7.51,7.51,0,0,0-2.64.57,7.12,7.12,0,0,0-.75.35l-.27.14s.08-.08.25-.18a7.14,7.14,0,0,1,.73-.39,7.09,7.09,0,0,1,5.38-.16,6.71,6.71,0,0,1,.76.34A1.18,1.18,0,0,1,241.57,191.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.92,247.24c.05,0,0,.47-.49,1a6.18,6.18,0,0,1-2.19,1.51,6.48,6.48,0,0,1-3.64.67c0-.16,1.61-.36,3.43-1.15a7.6,7.6,0,0,0,2.13-1.29C313.64,247.56,313.84,247.21,313.92,247.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.93,311c0-1.69-.08-93.78-.21-240.56l.21.21-367.38,0h0l.26-.26c0,85.54,0,166.94,0,240.56l-.24-.24,367.41.24-367.41.24h-.24V311c0-73.62,0-155,0-240.56v-.26h.29l367.38,0h.2v.21C565,217.23,564.93,309.32,564.93,311Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "533.04 274.92 525.82 262.6 518.97 274.92 421.76 274.92 421.76 325.74 573.13 325.74 573.13 274.92 533.04 274.92",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,300.77a7.44,7.44,0,0,0,4.5-6.86,7,7,0,1,0-14-.18,7.45,7.45,0,0,0,4.39,7C433.12,302.26,433.51,314,433.51,314l25.44.33S459.63,302.48,449,300.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.86,290c0,.15-19.32.26-43.15.26s-43.15-.11-43.15-.26,19.32-.26,43.15-.26S555.86,289.84,555.86,290Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.86,297.73c0,.14-19.32.26-43.15.26s-43.15-.12-43.15-.26,19.32-.26,43.15-.26S555.86,297.59,555.86,297.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.86,305.48c0,.14-19.32.26-43.15.26s-43.15-.12-43.15-.26,19.32-.26,43.15-.26S555.86,305.34,555.86,305.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.71,313.15c0,.14-9.66.26-21.57.26s-21.58-.12-21.58-.26,9.66-.26,21.58-.26S512.71,313,512.71,313.15Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.53,179.69c-.91-1.07-1.61-3-1.06-4.27-1.08-.57-1.17-1.52-1.17-2.73a7.35,7.35,0,0,1,1.05-3.45,10.05,10.05,0,0,1,3.89-4.27,5.2,5.2,0,0,1,5.54.24,6.72,6.72,0,0,1,9.62-.67,7.7,7.7,0,0,0,1.47,1.33c1,.53,2.14.33,3.23.43a5.67,5.67,0,0,1,4.69,7.88,6.11,6.11,0,0,1,2.61,4.7,18.07,18.07,0,0,1-.63,5.51c-.5,2.23-1.06,4.58-2.64,6.23a6.51,6.51,0,0,1-4.15,2,6.6,6.6,0,0,1-5.81-2.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.14,217.75l-17.92-.82c-.1-1.9.87-13.67.87-13.67s-6.78-1-6.86-7.83,1.09-22.33,1.09-22.33h0a23.54,23.54,0,0,1,23.66,3l1,.77Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.08,203.16a15.73,15.73,0,0,0,8.83-2.51s-2.09,4.88-8.85,4.27Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.14,183.87c.12-.05,4.66-1.38,4.51,3.25s-4.77,3.53-4.77,3.39S584.14,183.87,584.14,183.87Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.35,188.81s.08.05.21.12a.77.77,0,0,0,.61,0,2,2,0,0,0,1-1.76A2.73,2.73,0,0,0,587,186a.93.93,0,0,0-.59-.64.41.41,0,0,0-.48.21c-.07.12,0,.22-.07.22s-.09-.08-.05-.27a.49.49,0,0,1,.19-.28.62.62,0,0,1,.45-.11,1.14,1.14,0,0,1,.82.75,2.75,2.75,0,0,1,.24,1.3,2.09,2.09,0,0,1-1.24,2,.84.84,0,0,1-.73-.14C585.36,188.92,585.34,188.81,585.35,188.81Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.81,183.72a1,1,0,0,0,.93,1,.94.94,0,0,0,1-.88,1,1,0,0,0-.93-1A.93.93,0,0,0,561.81,183.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.6,182.63c.12.13.85-.41,1.89-.41s1.81.52,1.92.39-.07-.28-.4-.52a2.67,2.67,0,0,0-1.53-.48,2.62,2.62,0,0,0-1.51.49C561.65,182.35,561.54,182.57,561.6,182.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,184a1,1,0,0,0,.93,1,.93.93,0,0,0,1-.87,1,1,0,0,0-.94-1A.91.91,0,0,0,572,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.83,182.83c.12.12.86-.42,1.9-.42s1.8.53,1.91.4-.06-.29-.4-.53a2.65,2.65,0,0,0-1.53-.47,2.51,2.51,0,0,0-1.51.49C571.88,182.54,571.77,182.77,571.83,182.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.05,190.55a6.91,6.91,0,0,0-1.69-.31c-.26,0-.51-.08-.56-.26a1.38,1.38,0,0,1,.18-.79c.25-.64.51-1.32.79-2a33.73,33.73,0,0,0,1.76-5.3,35.61,35.61,0,0,0-2.19,5.14l-.75,2a1.56,1.56,0,0,0-.14,1,.65.65,0,0,0,.44.39,1.55,1.55,0,0,0,.45.06A6.74,6.74,0,0,0,568.05,190.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.12,191.27c-.17,0-.17,1.12-1.14,1.92s-2.17.68-2.18.83.27.22.78.24a2.88,2.88,0,0,0,1.82-.64,2.43,2.43,0,0,0,.88-1.61C571.32,191.54,571.2,191.26,571.12,191.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.56,178.75c.11.28,1.15.14,2.37.29s2.21.48,2.37.23-.1-.39-.5-.66A3.82,3.82,0,0,0,574,178a4,4,0,0,0-1.85.22C571.75,178.39,571.52,178.61,571.56,178.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562,179.62c.19.23.9,0,1.77,0s1.59.16,1.76-.09,0-.36-.36-.58a2.47,2.47,0,0,0-1.44-.39,2.38,2.38,0,0,0-1.4.48C562,179.26,561.9,179.5,562,179.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.34,176.54c-.09,2,.35,4.17,0,6.11-.06.29-.82,1.08-.88,1.37-.4,1.71-1.11,2.45-2.13.68a15.07,15.07,0,0,1-.8-3.34l-1.23-6.26a10.85,10.85,0,0,1-5.15,1.22,5.26,5.26,0,0,1-4.4-2.6,5.48,5.48,0,0,1-8.48,1.12,2.29,2.29,0,0,1-3,.64,2.71,2.71,0,0,1-1.1-3c.47-1.65,2.24-2.55,3.89-3,6.44-1.9,13.56-.41,19.35,3a9.4,9.4,0,0,1,2.34,1.76c.66.72,1.58,1.57,1.61,2.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.09,241.55,604,222.72c-1.44-4.84-6.61-10.08-13.8-11.45-2.29-.44-4.51-1.27-7.19-1.38h0a14.14,14.14,0,0,1-17.26.21l-.25-.18c-.69.08-1.61.17-2.76.31l-.23,0a16.94,16.94,0,0,0-7.93,3.16h0l-36.07,21.53-21.18-16.1-10.73,8.41s27.75,27.75,30.44,28.41c1.87.46,20.38-9.65,31.6-15.91-.46,6.72-3,44.07-2.85,49.17h51.54l0-23.55,0-6.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,263.61s25.1,11.07,27.5,11.59c8,1.75,15.29-4.93,14.12-11.22-.6-3.27-14.73-42.11-14.73-42.11L593.73,237l5.06,19.76-15.28-1.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599,273.26a1.76,1.76,0,0,0-.4-.22l-1.2-.59-4.51-2.1-15.36-7,.1.31,2.94-5.26c.63-1.12,1.25-2.23,1.83-3.28l-.22.12,18.37,1.8,5.46.49,1.48.11a2,2,0,0,0,.51,0,2.11,2.11,0,0,0-.5-.09l-1.47-.19-5.45-.63-18.36-2h-.14l-.08.13c-.58,1.05-1.2,2.15-1.83,3.28-1,1.8-2,3.56-2.93,5.26l-.12.22.22.1,15.43,6.87,4.56,2,1.23.51A1.82,1.82,0,0,0,599,273.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.45,254.12l2.15-10.47s-26.47-.34-26.18.13,2.8,24,2.8,24,18.62-.7,17.93-.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.52,249.35h0a2.45,2.45,0,0,0-2.3,1.57,5.4,5.4,0,0,1-1.57,2.51c-1.15.63-3.14,1.13-4.19.62s-5.23-4.28-6-3.86-1.36,1.36-.63,2.19,4.6,3.35,3.87,4.19-8.9-2.85-10.15-2.52-2,1.09-1.26,1.6,6.28,2.59,6.6,3.33c0,0-8.38-2.2-8.69-1.68s-.84,1.36,0,1.68,8.06,2.19,8.69,2.51a15.34,15.34,0,0,0,3.22.94,35.06,35.06,0,0,1,3.38,1.07,7.34,7.34,0,0,0,5.2-.14l.85-.35a3.3,3.3,0,0,0,2.06-3.27l-.17-2.86.92-2.35Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.21,256.63c-.15,0-.26-6-.26-13.43s.11-13.43.26-13.43.26,6,.26,13.43S597.35,256.63,597.21,256.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.34,223.78a6.64,6.64,0,0,1,0,1.24c0,.9-.06,2-.09,3.36-.11,2.83-.29,6.75-.52,11.07s-.48,8.24-.67,11.07c-.11,1.33-.2,2.45-.27,3.35a5.1,5.1,0,0,1-.17,1.23,6.72,6.72,0,0,1,0-1.24c0-.9.06-2,.1-3.36.1-2.83.28-6.75.52-11.08s.47-8.24.67-11.07c.1-1.33.19-2.45.26-3.35A4.94,4.94,0,0,1,549.34,223.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.71,229.77c0,.15-10.49.26-23.44.26s-23.45-.11-23.45-.26,10.5-.26,23.45-.26S596.71,229.63,596.71,229.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.8,232.39c0,.14-10.66.26-23.8.26s-23.81-.12-23.81-.26,10.66-.26,23.81-.26S596.8,232.24,596.8,232.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.2,235.74c0,.15-10.5.26-23.45.26s-23.45-.11-23.45-.26,10.5-.26,23.45-.26S597.2,235.6,597.2,235.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.8,256.65a53.16,53.16,0,0,1-2.9,5.68,55.15,55.15,0,0,1-3.09,5.57,30.46,30.46,0,0,1,2.63-5.82A31.1,31.1,0,0,1,593.8,256.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.7,257.37a48.22,48.22,0,0,1-6.42,11.14,57.61,57.61,0,0,1,3.13-5.61A56.07,56.07,0,0,1,596.7,257.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503,223.41c.12.12-2.21,2.33-5.18,4.93a50.46,50.46,0,0,1-5.56,4.5,48.92,48.92,0,0,1,5.21-4.9c1.49-1.3,2.85-2.45,3.85-3.27A10.16,10.16,0,0,1,503,223.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.46,225.24a49.21,49.21,0,0,1-5.25,5c-1.49,1.32-2.86,2.5-3.87,3.33a8.11,8.11,0,0,1-1.71,1.26,8.83,8.83,0,0,1,1.46-1.54c1-.9,2.28-2.12,3.78-3.44s2.87-2.49,3.88-3.32A9.33,9.33,0,0,1,505.46,225.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557,457.63l0-9,16.94-.21.22,13.23-1,.08c-4.67.32-23.77,1.28-26.91.37C542.66,461.05,557,457.63,557,457.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M568,461.55a5.91,5.91,0,0,1,2.12-3.63,5.67,5.67,0,0,1,3.95-1.28l.06,4.73Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M550,459.55s-5,1.52-4.38,2.34,20,.58,28.5-.28l0-.38-22.56.48S551,459.58,550,459.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M574.35,461.22l-.29,0-.84.06-3.07.17c-2.6.13-6.19.25-10.16.31s-7.57,0-10.17,0l-3.08-.09-.84,0-.29,0,.29,0h.84l3.08,0c2.6,0,6.19,0,10.16,0s7.56-.16,10.16-.25l3.08-.1.84,0A1.29,1.29,0,0,1,574.35,461.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.54,462a7.36,7.36,0,0,0-.6-1.47,7.17,7.17,0,0,0-1.06-1.16,2.75,2.75,0,0,1,1.66,2.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.5,459.38s-.29-.26-.54-.65-.42-.72-.37-.75.29.26.54.64S556.55,459.35,556.5,459.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.87,458.64s-.31-.14-.61-.4-.5-.5-.46-.54.3.13.6.39S557.9,458.59,557.87,458.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.71,457a2.1,2.1,0,0,1-.88.12,2.17,2.17,0,0,1-.89-.08,2.06,2.06,0,0,1,.88-.13A1.91,1.91,0,0,1,558.71,457Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559,455.89a1.74,1.74,0,0,1-1,.3,1.7,1.7,0,0,1-1-.12,5.44,5.44,0,0,1,1-.08A6.13,6.13,0,0,1,559,455.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.91,457.91a3.15,3.15,0,0,1-1.09,0,6,6,0,0,1-1.16-.24,3,3,0,0,1-.67-.26.56.56,0,0,1-.27-.34.42.42,0,0,1,.16-.43,2,2,0,0,1,2.84,1.27.71.71,0,0,1,0,.29,3.3,3.3,0,0,0-.51-.92,2,2,0,0,0-.94-.59,1.66,1.66,0,0,0-1.29.11c-.17.13-.1.33.09.44a3.09,3.09,0,0,0,.62.25,6.53,6.53,0,0,0,1.12.28C555.49,457.88,555.91,457.87,555.91,457.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.63,458a1.08,1.08,0,0,1-.14-.76,1.86,1.86,0,0,1,.29-.8,1.08,1.08,0,0,1,.9-.56.42.42,0,0,1,.34.49,1.19,1.19,0,0,1-.18.49,3.53,3.53,0,0,1-.5.67,1.59,1.59,0,0,1-.62.45s.21-.2.51-.55a3.6,3.6,0,0,0,.45-.66c.14-.23.24-.65,0-.69s-.55.25-.71.47a1.78,1.78,0,0,0-.3.71A3.33,3.33,0,0,0,555.63,458Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,456.59s-.49,0-1.25.06a5.46,5.46,0,0,0-2.72,1.16,5.52,5.52,0,0,0-1.68,2.43c-.24.73-.26,1.22-.3,1.22a1.17,1.17,0,0,1,0-.34,5,5,0,0,1,.18-.92,5.18,5.18,0,0,1,1.68-2.55,5.27,5.27,0,0,1,2.83-1.14,4,4,0,0,1,.93,0A1.26,1.26,0,0,1,574,456.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.1,449.56a29.34,29.34,0,0,1,.19,3.48,31.74,31.74,0,0,1,0,3.48,28.86,28.86,0,0,1-.19-3.47A29.27,29.27,0,0,1,572.1,449.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.82,459.93a9.7,9.7,0,0,1-2.47.28,9.91,9.91,0,0,1-2.48-.17c0-.06,1.11,0,2.48,0S565.81,459.87,565.82,459.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.14,459.88s-.09.24-.2.49-.17.48-.22.48-.09-.26,0-.56S569.1,459.84,569.14,459.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.37,458.31s-.06.22-.24.4-.34.29-.38.25.06-.22.24-.4S570.33,458.27,570.37,458.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.15,457.58c0,.05-.23.05-.48.15s-.43.22-.47.18.09-.27.4-.38S572.17,457.52,572.15,457.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.42,457.22c0,.06-.07.14-.21.2s-.27.06-.29,0,.07-.14.21-.2S573.4,457.17,573.42,457.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.47,451.88l1.62,6.78s11.09,14.41,14.51,13.7c2.24-.46-.52-4.22-4.73-15.16l-.89-4.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.05,470.24a1.52,1.52,0,0,1-.59.56,2.06,2.06,0,0,1-2.13-.29,62.77,62.77,0,0,1-5.52-5.23c-2-2.16-3.77-4.23-5-5.76l-1.41-1.82-.39-.5-.14-.17s0,.07.11.19l.35.52c.32.45.78,1.09,1.37,1.87a74.34,74.34,0,0,0,5,5.81,54.5,54.5,0,0,0,5.59,5.21,2.7,2.7,0,0,0,1.25.46,1.78,1.78,0,0,0,1-.22,1.25,1.25,0,0,0,.47-.43A.6.6,0,0,0,625.05,470.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.48,465.61a1.77,1.77,0,0,0-.91-.11,4.77,4.77,0,0,0-2.09.73,3.76,3.76,0,0,0-1.52,1.61,1.93,1.93,0,0,0-.24.88s.1-.33.36-.82a4.1,4.1,0,0,1,1.5-1.5,5.36,5.36,0,0,1,2-.75A8.3,8.3,0,0,1,623.48,465.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,462.23a1.57,1.57,0,0,0,.13-.33,5.59,5.59,0,0,0,.22-.93,5,5,0,0,0-.52-3.08,4.74,4.74,0,0,0-2.24-2.18,3.32,3.32,0,0,0-.91-.28,1,1,0,0,0-.35,0,8.17,8.17,0,0,1,1.2.44,4.84,4.84,0,0,1,2.12,2.14,5.18,5.18,0,0,1,.56,3C613.1,461.74,612.94,462.22,613,462.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.18,453s.2,1,.41,2.17a7.51,7.51,0,0,0,.57,2.13c.05,0-.17-1-.38-2.17A7.19,7.19,0,0,0,609.18,453Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.06,458.16a2.48,2.48,0,0,0-1.42,0,2.44,2.44,0,0,0-1.28.6c0,.06.58-.24,1.33-.41S620.06,458.22,620.06,458.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.29,459.32a1.75,1.75,0,0,0-1.2,0,1.66,1.66,0,0,0-1.05.58s.48-.25,1.1-.39S620.28,459.38,620.29,459.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.18,460.78a1.83,1.83,0,0,0-2.3.52,4.9,4.9,0,0,1,1.1-.49A5.49,5.49,0,0,1,621.18,460.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.3,457.67s-.51-.14-1.3-.44a10.1,10.1,0,0,1-1.34-.65,7,7,0,0,1-.74-.47c-.22-.16-.47-.41-.46-.67s.33-.41.59-.34a1.59,1.59,0,0,1,.68.45c.41.39.76.76,1,1.07.57.64.88,1.06.91,1a1.54,1.54,0,0,0-.19-.32,10,10,0,0,0-.61-.81,13.53,13.53,0,0,0-1-1.11,1.71,1.71,0,0,0-.77-.51.63.63,0,0,0-.83.52,1.08,1.08,0,0,0,.55.84,6.26,6.26,0,0,0,.76.47,8.38,8.38,0,0,0,1.38.62,7.65,7.65,0,0,0,1,.27A1.44,1.44,0,0,0,619.3,457.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.72,457.53s.07-.48.2-1.24a5.47,5.47,0,0,1,.38-1.28,2.63,2.63,0,0,1,.41-.65c.17-.19.43-.36.63-.24s.24.43.21.68a2.89,2.89,0,0,1-.22.74,4.16,4.16,0,0,1-.72,1.12c-.51.57-.92.84-.89.87a1,1,0,0,0,.29-.17,5,5,0,0,0,.7-.6,4.3,4.3,0,0,0,.79-1.14,2.77,2.77,0,0,0,.24-.8.83.83,0,0,0-.3-.87.72.72,0,0,0-.87.28,2.69,2.69,0,0,0-.44.71,4.87,4.87,0,0,0-.35,1.33c0,.39-.06.71-.07.92S618.7,457.53,618.72,457.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M610.09,458.66l-.78-3.26s2.71.51,3.42,2.54a8.65,8.65,0,0,1,.53,3.48l5.9,6.36s1.49-2.89,4.17-2.2c0,0,2.11,4.65,2,5.81s-1.42,1-1.9.81a23.77,23.77,0,0,1-5.29-4.18A121.77,121.77,0,0,1,610.09,458.66Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "545.59 284.44 553.66 455.18 575.83 455.71 574.08 307.67 607.24 455.99 625.05 455.18 596.52 284.79 545.59 284.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.65,286.75a15.21,15.21,0,0,0,.2,2.81c.18,1.72.46,4.1.81,6.73a26.85,26.85,0,0,0,.61,3.71,5.23,5.23,0,0,0,1.63,2.65,4.07,4.07,0,0,0,1.88.93,1.5,1.5,0,0,0,.77,0,4.72,4.72,0,0,1-3.86-3.7,31.71,31.71,0,0,1-.57-3.66c-.35-2.63-.68-5-1-6.72A17,17,0,0,0,568.65,286.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.1,287.76c-.06,0,.15.32,0,.77a.91.91,0,0,1-.47.55.73.73,0,0,1-.78-.19.71.71,0,0,1-.22-.76.88.88,0,0,1,.52-.5c.44-.16.73,0,.76,0s-.23-.4-.85-.28a1.18,1.18,0,0,0-.83.64,1.19,1.19,0,0,0,1.59,1.5,1.16,1.16,0,0,0,.6-.86C574.51,288,574.12,287.71,574.1,287.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.17,290.71a5,5,0,0,0-.33-4.73c-.13,0,.22,1.06.3,2.35S588,290.67,588.17,290.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585,290.39a4.23,4.23,0,0,0,.47-2.48,4.17,4.17,0,0,0-.64-2.45,21.23,21.23,0,0,0,.17,2.46A19.1,19.1,0,0,0,585,290.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.74,290.07a15.46,15.46,0,0,0-.06-2.55,15.07,15.07,0,0,0,0-2.55,4.75,4.75,0,0,0-.44,2.56A4.67,4.67,0,0,0,557.74,290.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.3,289.76c.13-.05-.24-1.18-.28-2.6s.24-2.58.11-2.62a4.13,4.13,0,0,0-.57,2.63A4.19,4.19,0,0,0,554.3,289.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "583.78 209.63 583.78 209.63 583.78 209.63 583.78 209.63",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,220s-4.09-6.92-5.05-7.64-9.56-3.71-10.29-3.47-11,2.18-9.83,3.39,8.4-.25,8.4-.25l1,.47s-6.22,1.1-7.52,1.88-.76,2.19.38,2,6.54-1.27,6.87-1.06-5.87,1.56-6.53,2c-.89.54-1,2.15.18,2.05.67-.06,6.5-1.67,6.5-1.67a50.64,50.64,0,0,0-5,2.28c-.69.68-.12,1.68.89,1.44.69-.16,3.94-1.78,4.86-2,0,0,.87.22,1.69,2s5.13,5.17,5.13,5.17Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.83,212.28a4.62,4.62,0,0,0,1.89.49,11.24,11.24,0,0,0,2.14.06c.79-.1,1.65-.24,2.56-.38l1.92-.32h-.12a28.67,28.67,0,0,0,4.49,1.32,27.35,27.35,0,0,0-4.34-1.76l-.05,0h-.06l-1.91.29-2.53.41a13.49,13.49,0,0,1-2.07.05C471.57,212.37,470.85,212.21,470.83,212.28Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.32,207.36s-7.46,22.63-10,27.2l25.4,7.76,4.62-2.95s6.17-18.22,6.95-24.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.1 238.53 478.76 242.32 483.38 239.37 480.1 238.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.43,222.93a17.83,17.83,0,0,1-2.84-.89l-6.79-2.34L467,217.47a18.39,18.39,0,0,1-2.8-1,17.51,17.51,0,0,1,2.91.65c1.78.48,4.22,1.21,6.88,2.1s5.05,1.79,6.76,2.48A15,15,0,0,1,483.43,222.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.27,228a15.72,15.72,0,0,1-2.79-.63c-1.7-.46-4-1.15-6.6-2s-4.85-1.67-6.49-2.31a14.89,14.89,0,0,1-2.62-1.15,16.14,16.14,0,0,1,2.74.8l6.53,2.17,6.54,2.13A16.46,16.46,0,0,1,481.27,228Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.7,232.63a80.65,80.65,0,0,1-8.55-2.61,76.23,76.23,0,0,1-8.37-3.1,154.8,154.8,0,0,1,16.92,5.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.37,220.74a2.05,2.05,0,0,1-2.4,0c-.75-.43-1.32-1.1-2-1.59-2.12-1.44-5.15-1-7.21-2.59-.28-.21-.57-.57-.42-.9s.54-.34.88-.34l8.52.07",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.7,215.43a3.19,3.19,0,0,0-.92-.11l-2.51-.09-3.73-.08-1.08,0a1.68,1.68,0,0,0-1.24.28.71.71,0,0,0-.13.8,1.31,1.31,0,0,0,.44.54,4.73,4.73,0,0,0,1.08.64,32.16,32.16,0,0,0,4.43,1.19,6.63,6.63,0,0,1,1.77.77c.5.33.92.73,1.34,1.06a3,3,0,0,0,2.41.81c.63-.13.83-.48.81-.48a2.44,2.44,0,0,1-.83.29,2.88,2.88,0,0,1-2.17-.88A16.79,16.79,0,0,0,489,219a6.11,6.11,0,0,0-1.86-.86,39.24,39.24,0,0,1-4.36-1.21,4.94,4.94,0,0,1-1-.57c-.28-.22-.42-.52-.27-.64s.53-.15.9-.14h1.08l3.73,0c1.06,0,1.92,0,2.51-.06A3.62,3.62,0,0,0,490.7,215.43Z",
    style: {
      fill: "#aa6550"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.68,179.72a7.77,7.77,0,0,0-3.18-7.78,8.38,8.38,0,0,0-8.46-.44,9.11,9.11,0,0,0-4.67,7.15c-.28,3.35,1.23,6.54,2.52,9.64s2.41,6.57,1.34,9.75c-.88,2.63-3.09,4.54-5,6.56a13.29,13.29,0,0,0-3.74,6.44c-.46,2.47.46,5.34,2.7,6.51a3.5,3.5,0,0,1,1.41.92c.62.88,0,2.05-.45,3a6.94,6.94,0,0,0-.23,4.69c1,3.36,4.71,5.51,8.22,5.31a11.51,11.51,0,0,0,8.64-5.36,19.86,19.86,0,0,0,2.9-10,75.5,75.5,0,0,0-.59-10.51c-.82-8.78,3.28-17.87,3.72-26.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.56,232.07h0a8.8,8.8,0,0,0,9.46-8.43c.18-4.79.34-9.62.34-9.62s7.25-.68,7.78-7.86.28-23.74.28-23.74h0A25,25,0,0,0,298.15,184l.45,25.26v13.59C298.65,227.44,301,231.72,305.56,232.07Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,197.4a3.67,3.67,0,0,0-4.91-1.07,4.17,4.17,0,0,0-1.39,5.21,5.54,5.54,0,0,0,3.52,2.67,2.74,2.74,0,0,1,2.16,3,9.24,9.24,0,0,1-2.52,5,13.26,13.26,0,0,1-8.3,3.94c-3.06.36-6.56-.28-8.34-2.79-1.3-1.83-1.39-4.22-1.43-6.46L294.45,191a22.64,22.64,0,0,1,.36-5.7,7.69,7.69,0,0,1,3-4.71c1.75-1.15,4-1.24,5.95-1.89,2.48-.8,4.59-2.45,6.92-3.64s5.18-1.9,7.51-.73c1.68.84,2.8,2.52,4.43,3.44,2.32,1.32,5.48,1,6.6,4.43a5.84,5.84,0,0,1,0,3.65c-1.58,4.65-7.33,6.52-11.47,4.51-.08.79.69,2.54-.13,5-.27.8-.36,2-1.6,2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,212.58a21.55,21.55,0,0,1-1.16-30",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.54,214.89s-.12.06-.37.11a4.2,4.2,0,0,1-1.09,0,6.06,6.06,0,0,1-3.51-1.83,18.11,18.11,0,0,1-3.17-5,31.94,31.94,0,0,1-2.36-6.8,25.78,25.78,0,0,1-.61-7.18,22.61,22.61,0,0,1,1.09-5.78,19.23,19.23,0,0,1,1.62-3.62c.24-.41.44-.71.58-.91s.23-.3.24-.29a31.9,31.9,0,0,0-2.08,4.93,23.92,23.92,0,0,0-1,5.69,26.41,26.41,0,0,0,.64,7,32.61,32.61,0,0,0,2.29,6.71,18.35,18.35,0,0,0,3,4.91,6.11,6.11,0,0,0,3.28,1.89A8.89,8.89,0,0,0,301.54,214.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.1,183.3c.08,0,.64,1,1.72,2.66a34.9,34.9,0,0,0,4.86,5.84,35.28,35.28,0,0,0,6,4.62c1.67,1,2.77,1.53,2.73,1.61a3.12,3.12,0,0,1-.82-.27,23.27,23.27,0,0,1-2.1-1,29.76,29.76,0,0,1-6.21-4.57,29,29,0,0,1-4.81-6,21,21,0,0,1-1.11-2.06A3,3,0,0,1,294.1,183.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,194.5a8.75,8.75,0,0,1-2.32-1.15,26.69,26.69,0,0,1-8.78-8.82,9,9,0,0,1-1.14-2.32,20.33,20.33,0,0,1,1.45,2.12,32.85,32.85,0,0,0,8.67,8.71A22.83,22.83,0,0,1,308,194.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.31,194.5a3.7,3.7,0,0,1-1-.08,19.75,19.75,0,0,1-2.66-.54A27.88,27.88,0,0,1,299,184.05a19.08,19.08,0,0,1-1.51-2.25,3.53,3.53,0,0,1-.45-.89c.08,0,.81,1.17,2.25,2.91a31.23,31.23,0,0,0,6.54,5.91,30.88,30.88,0,0,0,7.94,3.79C315.93,194.19,317.33,194.41,317.31,194.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.18,224.4s.14-.21.31-.63a3.15,3.15,0,0,0,.09-1.94,4.72,4.72,0,0,0-1.72-2.54c-.95-.79-2.22-1.41-3.55-2.29a8,8,0,0,1-1.86-1.69,4.64,4.64,0,0,1-.95-2.59,8.69,8.69,0,0,1,2.09-5.55c1.25-1.68,2.86-3.2,3.8-5.21a11.72,11.72,0,0,0,.75-6.7,31,31,0,0,0-1.92-6.66,50.18,50.18,0,0,1-2.08-6.2c-.46-2-.78-4.11-.07-6a4.34,4.34,0,0,1,1.76-2.12,3.25,3.25,0,0,1,2.53-.33,7.78,7.78,0,0,1,3.44,2.54l2.1,2.41,1.32,1.54a5.11,5.11,0,0,1,.43.56s-.19-.15-.51-.49l-1.39-1.47-2.16-2.36a7.75,7.75,0,0,0-3.32-2.38,2.9,2.9,0,0,0-2.23.32,4,4,0,0,0-1.57,1.94c-.64,1.68-.33,3.7.14,5.68a50.53,50.53,0,0,0,2.09,6.13,31,31,0,0,1,2,6.76,12.3,12.3,0,0,1-.81,7c-1,2.12-2.65,3.65-3.88,5.28a8.34,8.34,0,0,0-2,5.24,4.25,4.25,0,0,0,.84,2.37,7.7,7.7,0,0,0,1.75,1.63,39,39,0,0,1,3.52,2.37,4.85,4.85,0,0,1,1.73,2.72,3.16,3.16,0,0,1-.18,2A1.82,1.82,0,0,1,288.18,224.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.28,455.71l4.87-5.93-11-9.21-7.23,8.61.65.61c2.91,2.71,15,13.58,17.54,14.66C278.91,465.65,271.28,455.71,271.28,455.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262,452.43a5,5,0,0,0,.56-3.53,4.91,4.91,0,0,0-1.92-3L258,449Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.87,460.73s2.5,3.69,1.64,3.89S263,454.3,257.87,449.18l.23-.23,14.6,12.39S274.2,460.22,274.87,460.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,448.79s.05.07.17.18l.52.49,1.94,1.76c1.64,1.48,3.94,3.48,6.53,5.65s5,4.06,6.72,5.42l2.08,1.59.57.42.2.14-.18-.16-.55-.45-2.05-1.64c-1.72-1.38-4.09-3.3-6.68-5.46s-4.9-4.15-6.56-5.6l-2-1.72-.54-.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.56,461.51a6.64,6.64,0,0,1,1.17-.65,5.69,5.69,0,0,1,1.33-.19,2.32,2.32,0,0,0-2.5.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,457.14a1.67,1.67,0,0,0,.7-.14c.37-.12.66-.25.65-.3a1.65,1.65,0,0,0-.7.14C271,457,270.66,457.09,270.68,457.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.18,455.92c0,.05.27.08.6.06s.61-.06.6-.11a1.25,1.25,0,0,0-.6-.06C270.44,455.82,270.18,455.87,270.18,455.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.48,454.4s.2.29.52.56.59.46.63.42-.2-.28-.52-.55A2,2,0,0,0,270.48,454.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,453.51a2.16,2.16,0,0,0,1.23,1.19c0-.05-.29-.27-.62-.59S270.94,453.48,270.9,453.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.86,456.49a2.62,2.62,0,0,0,.71.58,5.32,5.32,0,0,0,.9.47,2.65,2.65,0,0,0,.58.18.53.53,0,0,0,.36-.07.4.4,0,0,0,.13-.38,1.72,1.72,0,0,0-2.56-.68.61.61,0,0,0-.18.18,2.67,2.67,0,0,1,.83-.34,1.76,1.76,0,0,1,.94.11,1.45,1.45,0,0,1,.79.77c.05.17-.11.27-.29.24a2.85,2.85,0,0,1-.55-.16,6.79,6.79,0,0,1-.89-.42C272.15,456.69,271.87,456.46,271.86,456.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,456.67s.26-.07.49-.42a1.34,1.34,0,0,0,.24-.68.9.9,0,0,0-.29-.85.36.36,0,0,0-.49.14,1,1,0,0,0-.14.42,2.93,2.93,0,0,0,0,.71,1.37,1.37,0,0,0,.17.62s0-.24,0-.63a2.77,2.77,0,0,1,.06-.67c0-.24.18-.56.39-.44s.22.46.21.69a1.5,1.5,0,0,1-.18.63A3.13,3.13,0,0,1,272,456.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.67,446a9.74,9.74,0,0,1,.8.71,4.5,4.5,0,0,1,1,4.72c-.23.61-.48.94-.45,1s.08-.07.19-.22a4.25,4.25,0,0,0,.37-.7,4.34,4.34,0,0,0-1-4.85,3.91,3.91,0,0,0-.62-.49C260.77,446,260.68,446,260.67,446Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.65,442.32a27.46,27.46,0,0,0-2,2.19,23.63,23.63,0,0,0-1.86,2.3,49.1,49.1,0,0,0,3.84-4.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.24,452.51a11.58,11.58,0,0,0,3.2,2.72s-.73-.6-1.61-1.35S264.28,452.48,264.24,452.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.08,450.7c-.05,0-.07.2-.13.43s-.15.41-.11.44.2-.13.27-.39S262.13,450.7,262.08,450.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.11,449c-.05,0-.07.17-.06.39s.08.37.12.37.08-.18.06-.39S262.16,449,262.11,449Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.33,447.57s.12.16.24.36.16.37.21.37.08-.23-.06-.46S261.35,447.52,261.33,447.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.68,446.66s0,.13,0,.24.14.19.19.16,0-.13,0-.24S260.72,446.63,260.68,446.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,458.17l-.17-7.68-14.38.23.13,11.24.89,0c4,.16,20.21.52,22.85-.33C334.3,460.73,322,458.17,322,458.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.82,461.76a5,5,0,0,0-1.88-3,4.85,4.85,0,0,0-3.38-1l.06,4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,459.63s4.3,1.17,3.78,1.88-16.95,1-24.2.45l0-.33,19.16-.13S327.19,459.68,328,459.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.4,461.63l.25,0,.71,0,2.62.08c2.21,0,5.26.06,8.63,0s6.42-.17,8.63-.28l2.61-.15.71-.05a.79.79,0,0,0,.25,0h-.25l-.71,0-2.61.09c-2.21.08-5.26.17-8.63.22s-6.42,0-8.63,0H307.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.79,461.73a5.36,5.36,0,0,1,.47-1.26,5.63,5.63,0,0,1,.87-1,2.32,2.32,0,0,0-1.34,2.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.51,459.64s.24-.23.44-.56.34-.62.3-.65-.24.22-.44.56S322.47,459.61,322.51,459.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.34,459s.25-.12.5-.35.41-.43.38-.47-.26.12-.5.35S321.3,459,321.34,459Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.58,457.69a1.62,1.62,0,0,0,.75.09.38.38,0,1,0,0-.18A2,2,0,0,0,320.58,457.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.31,456.74a1.48,1.48,0,0,0,.84.23,1.4,1.4,0,0,0,.86-.13,4.77,4.77,0,0,0-.85,0A4.24,4.24,0,0,0,320.31,456.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,458.38a2.87,2.87,0,0,0,.92,0,4.79,4.79,0,0,0,1-.24,2.06,2.06,0,0,0,.56-.24.53.53,0,0,0,.23-.29.35.35,0,0,0-.15-.36,1.69,1.69,0,0,0-2.09.52,1.88,1.88,0,0,0-.29.63.61.61,0,0,0,0,.25,2.58,2.58,0,0,1,.41-.8,1.6,1.6,0,0,1,.78-.52,1.4,1.4,0,0,1,1.1.05c.15.11.1.28-.06.38a2.42,2.42,0,0,1-.52.23,6.73,6.73,0,0,1-.95.27C323.33,458.34,323,458.35,323,458.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.22,458.42a1,1,0,0,0,.09-.64,1.45,1.45,0,0,0-.26-.68.93.93,0,0,0-.77-.46.37.37,0,0,0-.28.44,1,1,0,0,0,.16.41,2.6,2.6,0,0,0,.45.55c.29.28.52.38.53.36s-.19-.16-.45-.45a2.51,2.51,0,0,1-.39-.55c-.13-.19-.22-.54,0-.58s.47.2.61.38a1.51,1.51,0,0,1,.27.6A3.2,3.2,0,0,1,323.22,458.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.64,457.69s.41-.05,1.06,0a4.5,4.5,0,0,1,3.81,3c.23.61.26,1,.29,1a.74.74,0,0,0,0-.29,4.14,4.14,0,0,0-.17-.78,4.51,4.51,0,0,0-1.49-2.12,4.46,4.46,0,0,0-2.43-.9,3.65,3.65,0,0,0-.79,0C307.73,457.65,307.63,457.68,307.64,457.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,451.68a27.28,27.28,0,0,0-.07,3,24.17,24.17,0,0,0,.09,2.95,25.57,25.57,0,0,0,.08-2.95A23,23,0,0,0,309,451.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.61,460.33a9,9,0,0,0,2.11.18,8,8,0,0,0,2.1-.21c0-.05-.95,0-2.11,0S314.62,460.28,314.61,460.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.79,460.37s.08.2.18.41.16.4.21.4.07-.23-.05-.47S311.82,460.33,311.79,460.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,459.06s.06.19.21.33.3.25.34.21-.06-.18-.21-.33S310.74,459,310.71,459.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.18,458.48s.2,0,.42.12.36.18.4.15-.09-.23-.35-.32S309.17,458.44,309.18,458.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09,458.21c0,.05.07.12.19.17s.23,0,.25,0-.07-.11-.19-.16S308.11,458.17,308.09,458.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21,295s-4.79,20.26-3.43,24.27,10.12,6.33,10.12,6.33l-.29,55.49-48.53,60L277,455.76s52.53-60.1,57.16-71-3-90.65-3-90.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,286.77l2.38,168.53-24.69.12-16-134.54h0c-2.44-8-5.22-16.35-4.72-25.89l3.31-9.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.37,312.51a5,5,0,0,1,.58.5c.35.35.88.87,1.52,1.57,1.3,1.4,3.12,3.49,5.29,6.19l0,0v.06c.45,7.55,1.34,18.56,2.41,30.79.85,10,1.73,19.06,2.27,26.15v.07l-.05.06-6.87,9.2-1.9,2.5-.51.65-.19.21s0-.09.14-.25l.46-.68,1.82-2.57,6.73-9.3,0,.12c-.65-7.08-1.48-16.19-2.39-26.12-1.07-12.23-1.89-23.25-2.24-30.81l0,.1c-2.13-2.72-3.91-4.85-5.16-6.28-.62-.72-1.12-1.26-1.45-1.63A3.6,3.6,0,0,1,297.37,312.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.45,378.42a24.35,24.35,0,0,0-6.67-1.74,25.34,25.34,0,0,0-6.85.66,5.56,5.56,0,0,1,1.92-.75,15.15,15.15,0,0,1,9.82.78A5.32,5.32,0,0,1,324.45,378.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.16,386.22c.11.09-6.83,9.41-15.51,20.82s-15.81,20.59-15.92,20.5,6.82-9.41,15.51-20.82S333,386.14,333.16,386.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,299.29a4.25,4.25,0,0,1-1.39,1.83,6.88,6.88,0,0,1-10.07-1.06,4.08,4.08,0,0,1-1-2.08,21.62,21.62,0,0,0,1.26,1.85,6.86,6.86,0,0,0,9.54,1C331.42,300,331.87,299.23,332,299.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.76,250.58s-3.75,27.42,0,30.89,7.34,2.33,7.34,2.33l7.13-6,1.4-27.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.22,228.3s-5.36,6.06-6.47,29.23c0,0,15.27,2.9,15.55,2.06S282.22,228.3,282.22,228.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.93,295l48.65.79-.75-7.32s-5.36-27.87-5.32-28.23l.84-1.78a16.19,16.19,0,0,0,.41-14.08h23.62l-1-19.16-24.79-3.65-9.22-.73s-16.25.85-16.6.89c-6.8.82-14.71,1.34-17.6,8.62-1.55,3.89-.08,9.73,2.44,15.76l6,18.49c2.4,10.17-1.43,9.69-3.53,19.92C285.78,286.06,282.9,293.57,282.93,295Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58,226.08c0,.14-13.87.26-31,.26s-31-.12-31-.26,13.86-.27,31-.27S346.58,225.93,346.58,226.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,235.28c0,.15-15.42.26-34.45.26s-34.45-.11-34.45-.26,15.42-.26,34.45-.26S348,235.14,348,235.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.93,245.76a16,16,0,0,1-5.74,0,16,16,0,0,1,5.74,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,246.08c0,.14-10.09.26-22.53.26s-22.54-.12-22.54-.26,10.09-.26,22.54-.26S328,245.94,328,246.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,256.88c0,.14-9.06.26-20.23.26s-20.22-.12-20.22-.26,9.05-.26,20.22-.26S327,256.73,327,256.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.71,266.88c0,.14-8.21.26-18.33.26s-18.33-.12-18.33-.26,8.21-.26,18.33-.26S326.71,266.74,326.71,266.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.32,275c0,.14-8.78.26-19.61.26s-19.61-.12-19.61-.26,8.78-.26,19.61-.26S328.32,274.83,328.32,275Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86,285.3c0,.14-10,.26-22.31.26s-22.31-.12-22.31-.26,10-.26,22.31-.26S330.86,285.15,330.86,285.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.35,263.73a4,4,0,0,1-.41-.92c-.28-.72-.6-1.57-1-2.56-.82-2.17-2-5.15-3.19-8.47s-2.21-6.37-2.84-8.61c-.32-1.11-.55-2-.69-2.66a4.44,4.44,0,0,1-.16-1,36.13,36.13,0,0,1,1.2,3.56c.72,2.19,1.77,5.21,3,8.53s2.31,6.32,3.05,8.52c.37,1.1.65,2,.83,2.62A3.3,3.3,0,0,1,289.35,263.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M292.89,282a48.09,48.09,0,0,0,12.65-7.14,23,23,0,0,0,7.92-11.95c.21-.89.24-2.06-.57-2.49a1.57,1.57,0,0,0-1.79.45,6.32,6.32,0,0,0-1,1.72,12.46,12.46,0,0,1-4.31,5.09c-2.14,1.45-4.67,2.18-7.07,3.13s-4.82,2.22-6.26,4.36-1.57,5.36.33,7.1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M315,254.34s0,.14,0,.39,0,.64,0,1.13a26.72,26.72,0,0,1-.6,4.09,29.14,29.14,0,0,1-16.81,20.34,26.49,26.49,0,0,1-3.9,1.36c-.47.13-.84.2-1.09.25a1.46,1.46,0,0,1-.39.05,8.66,8.66,0,0,1,1.42-.49,32.81,32.81,0,0,0,3.81-1.51,30,30,0,0,0,16.6-20.09,34,34,0,0,0,.76-4A11,11,0,0,1,315,254.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.65,178.42s-.11-.62-.21-1.84a19.57,19.57,0,0,1,.42-5.41,22.42,22.42,0,0,1,12.8-15.63,24.64,24.64,0,0,1,6.93-1.91,26.78,26.78,0,0,1,7.92.17,29,29,0,0,1,15.68,8.32,34.61,34.61,0,0,1,6,8,31.75,31.75,0,0,1,3.37,10.1,30,30,0,0,1-.33,11.26,25.33,25.33,0,0,1-1.94,5.56,22.54,22.54,0,0,1-3.4,5,23,23,0,0,1-10.59,6.44,39.09,39.09,0,0,1-12.95,1.33A51.36,51.36,0,0,1,363,207.43a23.11,23.11,0,0,1-11.48-8,23.82,23.82,0,0,1-4.42-13.76,26.46,26.46,0,0,1,1-7.42,30.8,30.8,0,0,1,3.11-6.94,33.89,33.89,0,0,1,4.87-6,33.17,33.17,0,0,1,6.31-4.63,29.3,29.3,0,0,1,7.44-2.76,26.92,26.92,0,0,1,8-.42,31.73,31.73,0,0,1,25.53,18.77,27.41,27.41,0,0,1,1.49,16.82,21.87,21.87,0,0,1-3.6,7.9,19.41,19.41,0,0,1-6.68,5.65,24.08,24.08,0,0,1-8.47,2.49,30.29,30.29,0,0,1-8.91-.37,30.9,30.9,0,0,1-15.81-8.25,25.19,25.19,0,0,1-5.26-7.44,19.46,19.46,0,0,1-1.74-9c.34-6.23,3.65-12,8.25-16.21a29.24,29.24,0,0,1,16.71-7.48,25,25,0,0,1,9.15.81,24.89,24.89,0,0,1,8.16,4,22.63,22.63,0,0,1,6,6.74,19.62,19.62,0,0,1,1.83,4.14c.26.71.4,1.45.59,2.18s.28,1.48.33,2.23a24.18,24.18,0,0,1-4.64,16.82,26.15,26.15,0,0,1-14.37,9.44,28.17,28.17,0,0,1-16.88-.83c-10.64-3.86-18.87-13.35-20.64-24.09a23.24,23.24,0,0,1,2.69-15.5,27.06,27.06,0,0,1,11.09-10.65,33,33,0,0,1,14.55-3.6,38,38,0,0,1,14.33,2.49c9,3.4,16.35,10.21,19.58,18.57a28.45,28.45,0,0,1-2.11,24.68,23.17,23.17,0,0,1-8.53,8.2,28.1,28.1,0,0,1-10.75,3.35,36.57,36.57,0,0,1-20-4.07,44.41,44.41,0,0,1-14.17-10.93A28.62,28.62,0,0,1,349,181a22.06,22.06,0,0,1,1.34-11.88,19.82,19.82,0,0,1,5-7.25,16.5,16.5,0,0,1,4.56-2.93c1.15-.41,1.75-.59,1.75-.59l-.44.16c-.29.11-.73.26-1.29.48a16.9,16.9,0,0,0-4.51,3,19.83,19.83,0,0,0-4.9,7.23A22,22,0,0,0,349.2,181a28.42,28.42,0,0,0,6.56,13.34,44.31,44.31,0,0,0,14.11,10.83,36.32,36.32,0,0,0,19.88,4,27.92,27.92,0,0,0,10.61-3.32,22.73,22.73,0,0,0,8.38-8.1,28.08,28.08,0,0,0,2.06-24.34c-3.2-8.23-10.51-15-19.36-18.31a37.56,37.56,0,0,0-14.17-2.44,32.47,32.47,0,0,0-14.35,3.55A26.72,26.72,0,0,0,352,166.65a22.77,22.77,0,0,0-2.63,15.19c1.74,10.55,9.86,19.91,20.34,23.7a27.61,27.61,0,0,0,16.59.81,25.59,25.59,0,0,0,14.08-9.26A23.67,23.67,0,0,0,405,180.63c-.05-.73-.22-1.45-.33-2.18a21.72,21.72,0,0,0-2.35-6.16,22.4,22.4,0,0,0-5.91-6.59A24.2,24.2,0,0,0,379.41,161,28.72,28.72,0,0,0,363,168.3c-4.51,4.1-7.75,9.79-8.08,15.85a19,19,0,0,0,1.69,8.77,24.88,24.88,0,0,0,5.15,7.28,30.39,30.39,0,0,0,15.55,8.11,29.9,29.9,0,0,0,8.75.37,23.16,23.16,0,0,0,8.29-2.44,18.73,18.73,0,0,0,6.51-5.5,21.23,21.23,0,0,0,3.52-7.7,27,27,0,0,0-1.46-16.52A31.27,31.27,0,0,0,377.8,158a27,27,0,0,0-7.88.41,28.89,28.89,0,0,0-7.3,2.72,32.12,32.12,0,0,0-6.22,4.54,32.62,32.62,0,0,0-4.8,5.9,30.23,30.23,0,0,0-3.07,6.82,26.23,26.23,0,0,0-1,7.29,23.39,23.39,0,0,0,4.33,13.5A22.6,22.6,0,0,0,363.11,207a51.32,51.32,0,0,0,13.23,2.41,38.49,38.49,0,0,0,12.82-1.3,21.45,21.45,0,0,0,13.78-11.23,25,25,0,0,0,1.92-5.48,29.89,29.89,0,0,0,.35-11.13,32.58,32.58,0,0,0-9.22-18A28.8,28.8,0,0,0,380.47,154a26.33,26.33,0,0,0-7.85-.18,24.36,24.36,0,0,0-6.88,1.87,22,22,0,0,0-9.2,7.48,22.31,22.31,0,0,0-3.58,8,20.29,20.29,0,0,0-.47,5.39c0,.61.1,1.07.12,1.38S352.65,178.42,352.65,178.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,173.24c0,.13-6.51,2.31-14.63,4.86s-14.75,4.51-14.79,4.37,6.51-2.31,14.63-4.86S391.91,173.1,392,173.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.81,178c.05.13-6.06,2.36-13.64,5s-13.75,4.61-13.8,4.47,6.06-2.36,13.64-5S393.76,177.85,393.81,178Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,187.76c.16.22-3,1.47-6.82,2.83-1.92.68-3.68,1.26-5,1.66a8.76,8.76,0,0,1-2.11.54,9.31,9.31,0,0,1,2-.89c1.25-.48,3-1.12,4.91-1.8s3.68-1.28,4.95-1.7S382.67,187.74,382.62,187.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.26,192.47s-4.58-2.12-4.8-1,.09,1.57,1,1.85,3.39,1.12,3.39,1.12Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,194.56s-4.58-2.12-4.8-1,.08,1.56,1,1.85,3.39,1.12,3.39,1.12Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.47,199.24,360.09,222c-2.48,3.67-6.33,5.5-8.93,5.57l-1.63.14.81,15.51,6.86-.78a13.8,13.8,0,0,0,10.37-6.78l17.67-30.54a52.54,52.54,0,0,0,3.1-6.1c1-2.64-.08-6.59-.08-6.59l-7,4.42v-4.77s-.75-.26-2.21,1.17C377.79,194.52,377.47,199.24,377.47,199.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,190.06l.09,16.79a1.36,1.36,0,0,0,1.45,1.35h0a1.36,1.36,0,0,0,1.26-1.36v-17l-1.6-2.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.33 187.29 381.89 188.3 382.92 188.25 382.33 187.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.93,189.88a2.24,2.24,0,0,1-1.39.44,2.56,2.56,0,0,1-1.44-.25c0-.07.65.09,1.43.05S383.9,189.82,383.93,189.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5,208.2a4.16,4.16,0,0,1-.05-.71c0-.58,0-1.22,0-1.93,0-1.81,0-4-.05-6.37s0-4.55,0-6.36c0-.71,0-1.35,0-1.93a3.61,3.61,0,0,1,0-.71,5,5,0,0,1,0,.71c0,.58,0,1.22,0,1.93,0,1.81,0,4,0,6.36s0,4.56,0,6.37c0,.71,0,1.35,0,1.93A6.87,6.87,0,0,1,382.5,208.2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,391c7.82,2.73,18,.29,24.73-4.6s11.51-11.89,15.78-19c1.82-3,3.6-6.19,4.18-9.68s-.28-7.42-3-9.7c-4.21-3.54-10.66-1.74-15.43,1A53.22,53.22,0,0,0,148,391",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.38,409.7c4.7,6.2,12.77,9,20.55,9.32s15.45-1.78,22.71-4.57c2.64-1,5.52-2.4,6.43-5.07a6.46,6.46,0,0,0-1.38-6,13.31,13.31,0,0,0-5.24-3.57c-7.15-3.05-15.35-3.19-22.87-1.24s-14.1,6.31-20.2,11.12",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,357.44c6.48.13,11.38-5.54,14.32-11.32A42,42,0,0,0,166,320c-.6-3.31-1.85-6.88-4.81-8.48s-6.93-.55-9.45,1.76-3.91,5.59-4.92,8.86c-3.48,11.25-2.73,24.18,1,35.35",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.58,393.28c11-18.8,12.89-41.81,6.36-62.61-1.06-3.38-3.05-7.24-6.58-7.46-3.91-.25-6.36,4.11-7.44,7.87-3.79,13.22-3,27.25-2.15,41,.52,8.45,3.42,15.67,9.81,21.23",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,401a45.16,45.16,0,0,0-26.8-28.43c-2.94-1.1-6.66-1.73-8.85.51S78,379,79.33,381.72c2.22,4.44,5.83,8,9.43,11.43,3.27,3.12,6.67,6.24,10.81,8.05s11.74,2.27,15.52-.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.58,352.71a.88.88,0,0,1-.19.17l-.6.46-2.32,1.73-1.67,1.24c-.61.47-1.24,1-1.93,1.57-1.37,1.14-3,2.37-4.61,3.92l-2.6,2.37c-.91.83-1.77,1.76-2.71,2.69-1.9,1.82-3.74,4-5.72,6.16A121.83,121.83,0,0,0,141,405.68c-1.09,2.76-2.17,5.36-3,7.88-.41,1.25-.86,2.45-1.19,3.62s-.65,2.31-1,3.39c-.65,2.15-1,4.14-1.44,5.87-.19.87-.39,1.68-.54,2.43l-.36,2.05q-.33,1.81-.51,2.85l-.15.74a1.23,1.23,0,0,1-.07.25,1,1,0,0,1,0-.26c0-.2.05-.44.09-.75.1-.69.24-1.65.42-2.86.09-.62.2-1.32.31-2.07s.33-1.56.5-2.44c.39-1.74.74-3.75,1.38-5.91l.92-3.4c.33-1.19.77-2.39,1.17-3.65.77-2.53,1.85-5.15,2.92-7.92a132.08,132.08,0,0,1,8.8-17.23,130.52,130.52,0,0,1,11.47-15.56c2-2.21,3.86-4.34,5.78-6.16,1-.92,1.83-1.85,2.74-2.67l2.64-2.35c1.64-1.54,3.28-2.75,4.67-3.88.7-.55,1.34-1.08,1.95-1.53l1.71-1.21,2.38-1.65.63-.42C183.5,352.75,183.57,352.7,183.58,352.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.21,404.82a3.49,3.49,0,0,1-.76-.12c-.5-.09-1.21-.28-2.15-.44A59.33,59.33,0,0,0,135,429.36c-.55.78-.92,1.42-1.2,1.83a4,4,0,0,1-.45.63,5.26,5.26,0,0,1,.36-.68c.25-.43.6-1.09,1.12-1.89a53.89,53.89,0,0,1,4.84-6.49,57.38,57.38,0,0,1,47.68-19.84,52.87,52.87,0,0,1,8,1.14c.93.19,1.65.41,2.13.53A7.15,7.15,0,0,1,198.21,404.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.41,319a1.58,1.58,0,0,1,0,.29c-.05.22-.11.5-.18.85-.17.77-.42,1.86-.72,3.23-.64,2.81-1.61,6.86-2.83,11.87-2.43,10-6,23.79-9.65,39.06-1.84,7.64-3.49,14.94-4.92,21.59s-2.6,12.67-3.49,17.74c-.47,2.53-.83,4.83-1.17,6.85s-.62,3.75-.83,5.18-.38,2.49-.5,3.27l-.15.86a1.24,1.24,0,0,1-.07.28,1.27,1.27,0,0,1,0-.29c0-.22.05-.51.09-.86.1-.79.24-1.89.41-3.29s.42-3.18.74-5.2.65-4.32,1.1-6.86c.84-5.08,2-11.11,3.38-17.78s3.05-14,4.88-21.61c3.68-15.28,7.28-29.05,9.8-39,1.26-5,2.27-9,3-11.83.35-1.36.62-2.44.82-3.21.09-.34.17-.61.23-.83A1.09,1.09,0,0,1,157.41,319Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,428.54s0-.07-.07-.23-.1-.4-.16-.68q-.19-1-.54-2.61c-.47-2.28-1.09-5.58-1.8-9.67-1.42-8.18-3.09-19.54-4.13-32.17-.5-6.32-.78-12.35-.9-17.84s0-10.44.13-14.59c0-2.07.19-3.95.28-5.6s.2-3.06.3-4.21.19-2,.25-2.67l.08-.69a.89.89,0,0,1,0-.23.87.87,0,0,1,0,.24c0,.19,0,.41,0,.69,0,.66-.08,1.55-.14,2.67s-.16,2.57-.22,4.22-.18,3.52-.2,5.59c-.13,4.15-.14,9.09,0,14.57s.44,11.5.94,17.81c1,12.61,2.65,24,4,32.15.67,4.1,1.23,7.41,1.64,9.69.18,1.11.33,2,.44,2.64l.11.68A2.18,2.18,0,0,1,132.05,428.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.86,430.93a6.46,6.46,0,0,1-.29-.65l-.72-1.89-.52-1.37c-.22-.49-.46-1-.71-1.59s-.53-1.18-.81-1.82-.66-1.3-1-2l-1.12-2.19c-.44-.74-.88-1.51-1.35-2.31-.88-1.62-2-3.23-3.14-5a117,117,0,0,0-8.32-10.64,130.21,130.21,0,0,0-9.55-9.55c-1.58-1.34-3-2.68-4.51-3.81l-2.09-1.66-2-1.47c-1.26-.95-2.43-1.74-3.47-2.44s-1.93-1.3-2.68-1.75l-1.71-1.09a3,3,0,0,1-.58-.41,5.3,5.3,0,0,1,.63.32l1.77,1c.77.43,1.68,1,2.73,1.69s2.25,1.45,3.52,2.39l2,1.44,2.12,1.65c1.49,1.11,3,2.44,4.56,3.78a123.51,123.51,0,0,1,9.62,9.57,111.73,111.73,0,0,1,8.33,10.71c1.1,1.77,2.24,3.4,3.12,5q.67,1.22,1.32,2.34l1.1,2.22c.34.71.7,1.37,1,2s.53,1.27.78,1.85l.67,1.61c.17.5.33,1,.48,1.39l.63,1.93A3.32,3.32,0,0,1,132.86,430.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,374.51a32.39,32.39,0,0,1-3.49.21,65.37,65.37,0,0,0-8.34,1,66.21,66.21,0,0,0-8.13,2.11c-2,.68-3.28,1.17-3.32,1.1a3,3,0,0,1,.83-.45c.55-.27,1.36-.61,2.37-1a50.82,50.82,0,0,1,8.16-2.29,49.62,49.62,0,0,1,8.42-.86c1.08,0,2,0,2.56,0A3.78,3.78,0,0,1,179.48,374.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.81,415.22a25.25,25.25,0,0,0-11.05-11.9,7.33,7.33,0,0,1,2.25,1,19.8,19.8,0,0,1,8,8.59A7.4,7.4,0,0,1,187.81,415.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.4,334.24c.1.11-1.93,2.13-4.15,4.86s-3.8,5.12-3.93,5a23,23,0,0,1,3.53-5.37A22.47,22.47,0,0,1,159.4,334.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.72,322.72a18.29,18.29,0,0,1,1,4.36,19,19,0,0,1,.49,4.44,39.47,39.47,0,0,1-1.5-8.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.06,358.88a53.92,53.92,0,0,1-3.23,6.81,54.48,54.48,0,0,1-3.7,6.56,55,55,0,0,1,3.23-6.8A56.16,56.16,0,0,1,132.06,358.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.76,346.61a29.85,29.85,0,0,1,2.74,4.92,29.87,29.87,0,0,1,2.27,5.15,31.69,31.69,0,0,1-2.74-4.92A30.84,30.84,0,0,1,119.76,346.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68,388.6c0,.15-2.22-.28-5-.47s-5-.08-5-.24a14.51,14.51,0,0,1,5-.28A14.38,14.38,0,0,1,101.68,388.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,425.73l6.15,32.34a4.52,4.52,0,0,0,4.45,3.68H142.8a4.52,4.52,0,0,0,4.47-3.79l5.35-32.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.03 436.24 150.77 436.24 152.62 425.73 114.03 425.73 116.03 436.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.03 436.24 116.76 440.07 150.24 440.07 150.77 436.24 116.03 436.24",
    style: {
      fill: "#fafafa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsPana);
export default __webpack_public_path__ + "static/media/Events-pana.e19639d6abe82f37a10c97c6217808cc.svg";
export { ForwardRef as ReactComponent };